import React, { useState } from 'react';
import { faqs } from '../data/viajes';
import { WA_DUDA } from '../services/whatsapp';
import './FAQ.css';

export default function FAQ() {
  const [abierta, setAbierta] = useState(0);
  return (
    <section id="preguntas" className="faq sec">
      <div className="wrap faq__grid">
        <div className="faq__intro">
          <p className="eyebrow">Preguntas frecuentes</p>
          <h2 className="h2">Lo que <em>todos</em> me preguntan</h2>
          <p className="lead">¿Tienes otra duda? Escríbeme y te respondo personalmente.</p>
          <a className="btn-wa faq__cta" href={WA_DUDA} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp" />Pregúntame por WhatsApp</a>
        </div>
        <div className="faq__lista">
          {faqs.map((q, i) => {
            const on = abierta === i;
            return (
              <div key={q.pregunta} className={`faq__item ${on ? 'is-on' : ''}`}>
                <button className="faq__q" onClick={() => setAbierta(on ? -1 : i)} aria-expanded={on}>
                  <span>{q.pregunta}</span><i className="fa-solid fa-plus" />
                </button>
                <div className="faq__a">
                  {/* Las respuestas vienen de data/viajes.js (contenido propio con <strong>) */}
                  <p dangerouslySetInnerHTML={{ __html: q.respuesta }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
